export const GET_ALL_CONSTANTS_STARTED = 'GET_ALL_CONSTANTS_STARTED';
export const GET_ALL_CONSTANTS_SUCCESS = 'GET_ALL_CONSTANTS_SUCCESS';
export const GET_ALL_CONSTANTS_FAILURE = 'GET_ALL_CONSTANTS_FAILURE';
